export enum listAction {
    Delete = 0,
    Restore = 1,
    Archive = 2
}